// Thin wrapper around authenticatedFetch. Mirrors Offboarding/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/teamatical-prep';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    let body = null;
    try {
      const raw = await resp.text();
      try {
        body = JSON.parse(raw);
        const d = body.detail;
        detail = typeof d === 'string' ? d : d?.message ? d.message : raw;
      } catch {
        detail = raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240);
      }
    } catch { /* status alone is enough */ }
    const err = new Error(detail || `${resp.status} ${resp.statusText}`);
    err.status = resp.status;
    err.body = body;
    throw err;
  }
  return resp.json();
}

const postJson = (path, body) => authenticatedFetch(`${BASE}${path}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
}).then(jsonOrThrow);

export const api = {
  preview: (pairs) => postJson('/preview', { pairs }),
  csvPreview: (file) => {
    const form = new FormData();
    form.append('file', file);
    return authenticatedFetch(`${BASE}/csv-preview`, { method: 'POST', body: form }).then(jsonOrThrow);
  },
  prepare: (item, confirmed) => postJson('/prepare', {
    shopify_url: item.shopify_url, teamatical_url: item.teamatical_url, confirmed,
  }),
  // Blob, not a plain <img src>: the route needs the auth header.
  teamaticalImage: async (teamaticalId) => {
    const resp = await authenticatedFetch(`${BASE}/teamatical-image/${encodeURIComponent(teamaticalId)}`);
    if (!resp.ok) throw new Error(`${resp.status}`);
    return resp.blob();
  },
  history: () => authenticatedFetch(`${BASE}/history`).then(jsonOrThrow),
  retry: (runId) => postJson(`/history/${runId}/retry`, {}),
  audit: () => authenticatedFetch(`${BASE}/audit`).then(jsonOrThrow),
  runAudit: () => postJson('/audit/run', {}),
  ignore: (row, reason) => postJson('/audit/ignore', { product_id: row.product_id, title: row.title, reason }),
  unignore: (row) => postJson('/audit/unignore', { product_id: row.product_id }),
};
